import { render, staticRenderFns } from "./Circulars.vue?vue&type=template&id=8dc5b9b2&scoped=true"
import script from "./Circulars.vue?vue&type=script&lang=js"
export * from "./Circulars.vue?vue&type=script&lang=js"
import style0 from "./Circulars.vue?vue&type=style&index=0&id=8dc5b9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5b9b2",
  null
  
)

export default component.exports